export const openrouterModels = {
    id: "openrouter",
    name: "OpenRouter",
    api: "https://openrouter.ai/api/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://openrouter.ai/models",
    env: ["OPENROUTER_API_KEY"],
    models: {
        "deepseek/deepseek-r1-0528:free": {
            id: "deepseek/deepseek-r1-0528:free",
            name: "R1 0528 (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-28",
            last_updated: "2025-05-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "deepseek/deepseek-chat-v3.1": {
            id: "deepseek/deepseek-chat-v3.1",
            name: "DeepSeek-V3.1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-08-21",
            last_updated: "2025-08-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "deepseek/deepseek-r1-distill-llama-70b": {
            id: "deepseek/deepseek-r1-distill-llama-70b",
            name: "DeepSeek R1 Distill Llama 70B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-01-23",
            last_updated: "2025-01-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "deepseek/deepseek-v3-base:free": {
            id: "deepseek/deepseek-v3-base:free",
            name: "DeepSeek V3 Base (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2025-03",
            release_date: "2025-03-29",
            last_updated: "2025-03-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "deepseek/deepseek-r1-0528-qwen3-8b:free": {
            id: "deepseek/deepseek-r1-0528-qwen3-8b:free",
            name: "Deepseek R1 0528 Qwen3 8B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-29",
            last_updated: "2025-05-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "deepseek/deepseek-chat-v3-0324": {
            id: "deepseek/deepseek-chat-v3-0324",
            name: "DeepSeek V3 0324",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-03-24",
            last_updated: "2025-03-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 16384,
                output: 8192,
            },
        },
        "deepseek/deepseek-r1:free": {
            id: "deepseek/deepseek-r1:free",
            name: "R1 (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-01-20",
            last_updated: "2025-01-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "deepseek/deepseek-r1-distill-qwen-14b": {
            id: "deepseek/deepseek-r1-distill-qwen-14b",
            name: "DeepSeek R1 Distill Qwen 14B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-01-29",
            last_updated: "2025-01-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 64000,
                output: 8192,
            },
        },
        "rekaai/reka-flash-3": {
            id: "rekaai/reka-flash-3",
            name: "Reka Flash 3",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-03-12",
            last_updated: "2025-03-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "featherless/qwerky-72b": {
            id: "featherless/qwerky-72b",
            name: "Qwerky 72B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-03-20",
            last_updated: "2025-03-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "openrouter/horizon-beta": {
            id: "openrouter/horizon-beta",
            name: "Horizon Beta",
            attachment: true,
            reasoning: false,
            temperature: false,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 256000,
                output: 128000,
            },
        },
        "openrouter/cypher-alpha:free": {
            id: "openrouter/cypher-alpha:free",
            name: "Cypher Alpha (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-07-01",
            last_updated: "2025-07-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 1000000,
                output: 1000000,
            },
        },
        "openrouter/sonoma-dusk-alpha": {
            id: "openrouter/sonoma-dusk-alpha",
            name: "Sonoma Dusk Alpha",
            attachment: true,
            reasoning: false,
            temperature: false,
            tool_call: true,
            release_date: "2024-09-05",
            last_updated: "2024-09-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 2000000,
                output: 2000000,
            },
        },
        "openrouter/sonoma-sky-alpha": {
            id: "openrouter/sonoma-sky-alpha",
            name: "Sonoma Sky Alpha",
            attachment: true,
            reasoning: false,
            temperature: false,
            tool_call: true,
            release_date: "2024-09-05",
            last_updated: "2024-09-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 2000000,
                output: 2000000,
            },
        },
        "openrouter/horizon-alpha": {
            id: "openrouter/horizon-alpha",
            name: "Horizon Alpha",
            attachment: true,
            reasoning: false,
            temperature: false,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-07-30",
            last_updated: "2025-07-30",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 256000,
                output: 128000,
            },
        },
        "anthropic/claude-sonnet-4": {
            id: "anthropic/claude-sonnet-4",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "anthropic/claude-opus-4": {
            id: "anthropic/claude-opus-4",
            name: "Claude Opus 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "anthropic/claude-3.5-haiku": {
            id: "anthropic/claude-3.5-haiku",
            name: "Claude Haiku 3.5",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07-31",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 4,
                cache_read: 0.08,
                cache_write: 1,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "anthropic/claude-opus-4.1": {
            id: "anthropic/claude-opus-4.1",
            name: "Claude Opus 4.1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "anthropic/claude-3.7-sonnet": {
            id: "anthropic/claude-3.7-sonnet",
            name: "Claude Sonnet 3.7",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-01",
            release_date: "2025-02-19",
            last_updated: "2025-02-19",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 128000,
            },
        },
        "openai/gpt-5-nano": {
            id: "openai/gpt-5-nano",
            name: "GPT-5 Nano",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-01",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.05,
                output: 0.4,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-4.1": {
            id: "openai/gpt-4.1",
            name: "GPT-4.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 8,
                cache_read: 0.5,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/gpt-oss-20b": {
            id: "openai/gpt-oss-20b",
            name: "GPT OSS 20B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.05,
                output: 0.2,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "openai/gpt-5": {
            id: "openai/gpt-5",
            name: "GPT-5",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-01",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-5-chat": {
            id: "openai/gpt-5-chat",
            name: "GPT-5 Chat (latest)",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-09-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-5-mini": {
            id: "openai/gpt-5-mini",
            name: "GPT-5 Mini",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-01",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 2,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-4o-mini": {
            id: "openai/gpt-4o-mini",
            name: "GPT-4o-mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-07-18",
            last_updated: "2024-07-18",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.15,
                output: 0.6,
                cache_read: 0.08,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/gpt-4.1-mini": {
            id: "openai/gpt-4.1-mini",
            name: "GPT-4.1 Mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 1.6,
                cache_read: 0.1,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/gpt-oss-120b": {
            id: "openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.072,
                output: 0.28,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "openai/o4-mini": {
            id: "openai/o4-mini",
            name: "o4 Mini",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.1,
                output: 4.4,
                cache_read: 0.28,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "thudm/glm-z1-32b:free": {
            id: "thudm/glm-z1-32b:free",
            name: "GLM Z1 32B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-17",
            last_updated: "2025-04-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "sarvamai/sarvam-m:free": {
            id: "sarvamai/sarvam-m:free",
            name: "Sarvam-M (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-25",
            last_updated: "2025-05-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "x-ai/grok-code-fast-1": {
            id: "x-ai/grok-code-fast-1",
            name: "Grok Code Fast 1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-08",
            release_date: "2025-08-26",
            last_updated: "2025-08-26",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.2,
                output: 1.5,
                cache_read: 0.02,
            },
            limit: {
                context: 256000,
                output: 10000,
            },
        },
        "x-ai/grok-3-mini-beta": {
            id: "x-ai/grok-3-mini-beta",
            name: "Grok 3 Mini Beta",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 0.5,
                cache_read: 0.075,
                cache_write: 0.5,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "x-ai/grok-3": {
            id: "x-ai/grok-3",
            name: "Grok 3",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.75,
                cache_write: 15,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "x-ai/grok-3-mini": {
            id: "x-ai/grok-3-mini",
            name: "Grok 3 Mini",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 0.5,
                cache_read: 0.075,
                cache_write: 0.5,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "x-ai/grok-4": {
            id: "x-ai/grok-4",
            name: "Grok 4",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-07-09",
            last_updated: "2025-07-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.75,
                cache_write: 15,
            },
            limit: {
                context: 256000,
                output: 64000,
            },
        },
        "x-ai/grok-3-beta": {
            id: "x-ai/grok-3-beta",
            name: "Grok 3 Beta",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.75,
                cache_write: 15,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "mistralai/codestral-2508": {
            id: "mistralai/codestral-2508",
            name: "Codestral 2508",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 0.9,
            },
            limit: {
                context: 256000,
                output: 256000,
            },
        },
        "mistralai/mistral-medium-3": {
            id: "mistralai/mistral-medium-3",
            name: "Mistral Medium 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-07",
            last_updated: "2025-05-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 2,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "mistralai/devstral-small-2505": {
            id: "mistralai/devstral-small-2505",
            name: "Devstral Small",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-07",
            last_updated: "2025-05-07",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.06,
                output: 0.12,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistralai/mistral-small-3.2-24b-instruct:free": {
            id: "mistralai/mistral-small-3.2-24b-instruct:free",
            name: "Mistral Small 3.2 24B (free)",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-06",
            release_date: "2025-06-20",
            last_updated: "2025-06-20",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 96000,
                output: 96000,
            },
        },
        "mistralai/devstral-medium-2507": {
            id: "mistralai/devstral-medium-2507",
            name: "Devstral Medium",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-07-10",
            last_updated: "2025-07-10",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.4,
                output: 2,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "mistralai/mistral-small-3.2-24b-instruct": {
            id: "mistralai/mistral-small-3.2-24b-instruct",
            name: "Mistral Small 3.2 24B Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-06-20",
            last_updated: "2025-06-20",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 96000,
                output: 8192,
            },
        },
        "mistralai/devstral-small-2507": {
            id: "mistralai/devstral-small-2507",
            name: "Devstral Small 1.1",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-07-10",
            last_updated: "2025-07-10",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.3,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "mistralai/mistral-nemo:free": {
            id: "mistralai/mistral-nemo:free",
            name: "Mistral Nemo (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2024-07-19",
            last_updated: "2024-07-19",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "mistralai/mistral-small-3.1-24b-instruct": {
            id: "mistralai/mistral-small-3.1-24b-instruct",
            name: "Mistral Small 3.1 24B Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-03-17",
            last_updated: "2025-03-17",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "mistralai/mistral-7b-instruct:free": {
            id: "mistralai/mistral-7b-instruct:free",
            name: "Mistral 7B Instruct (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2024-05-27",
            last_updated: "2024-05-27",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "mistralai/mistral-medium-3.1": {
            id: "mistralai/mistral-medium-3.1",
            name: "Mistral Medium 3.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-08-12",
            last_updated: "2025-08-12",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 2,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "mistralai/devstral-small-2505:free": {
            id: "mistralai/devstral-small-2505:free",
            name: "Devstral Small 2505 (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-21",
            last_updated: "2025-05-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "meta-llama/llama-4-scout:free": {
            id: "meta-llama/llama-4-scout:free",
            name: "Llama 4 Scout (free)",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 64000,
                output: 64000,
            },
        },
        "meta-llama/llama-3.2-11b-vision-instruct": {
            id: "meta-llama/llama-3.2-11b-vision-instruct",
            name: "Llama 3.2 11B Vision Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-12",
            release_date: "2024-09-25",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "meta-llama/llama-3.3-70b-instruct:free": {
            id: "meta-llama/llama-3.3-70b-instruct:free",
            name: "Llama 3.3 70B Instruct (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 65536,
                output: 65536,
            },
        },
        "google/gemini-2.5-pro": {
            id: "google/gemini-2.5-pro",
            name: "Gemini 2.5 Pro",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-03-20",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "google/gemma-3-12b-it": {
            id: "google/gemma-3-12b-it",
            name: "Gemma 3 12B IT",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-03-13",
            last_updated: "2025-03-13",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 96000,
                output: 8192,
            },
        },
        "google/gemini-2.0-flash-001": {
            id: "google/gemini-2.0-flash-001",
            name: "Gemini 2.0 Flash",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.1,
                output: 0.4,
                cache_read: 0.025,
            },
            limit: {
                context: 1048576,
                output: 8192,
            },
        },
        "google/gemini-2.0-flash-exp:free": {
            id: "google/gemini-2.0-flash-exp:free",
            name: "Gemini 2.0 Flash Experimental (free)",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 1048576,
                output: 1048576,
            },
        },
        "google/gemma-3n-e4b-it:free": {
            id: "google/gemma-3n-e4b-it:free",
            name: "Gemma 3n 4B (free)",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-20",
            last_updated: "2025-05-20",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "google/gemma-2-9b-it:free": {
            id: "google/gemma-2-9b-it:free",
            name: "Gemma 2 9B (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-06-28",
            last_updated: "2024-06-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "google/gemini-2.5-flash": {
            id: "google/gemini-2.5-flash",
            name: "Gemini 2.5 Flash",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-07-17",
            last_updated: "2025-07-17",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 2.5,
                cache_read: 0.0375,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "google/gemini-2.5-pro-preview-06-05": {
            id: "google/gemini-2.5-pro-preview-06-05",
            name: "Gemini 2.5 Pro Preview 06-05",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-05",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "google/gemini-2.5-pro-preview-05-06": {
            id: "google/gemini-2.5-pro-preview-05-06",
            name: "Gemini 2.5 Pro Preview 05-06",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-05-06",
            last_updated: "2025-05-06",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "google/gemma-3n-e4b-it": {
            id: "google/gemma-3n-e4b-it",
            name: "Gemma 3n E4B IT",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-05-20",
            last_updated: "2025-05-20",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "google/gemma-3-27b-it": {
            id: "google/gemma-3-27b-it",
            name: "Gemma 3 27B IT",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-03-12",
            last_updated: "2025-03-12",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 96000,
                output: 8192,
            },
        },
        "microsoft/mai-ds-r1:free": {
            id: "microsoft/mai-ds-r1:free",
            name: "MAI DS R1 (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-21",
            last_updated: "2025-04-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "z-ai/glm-4.5-air:free": {
            id: "z-ai/glm-4.5-air:free",
            name: "GLM 4.5 Air (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 96000,
            },
        },
        "z-ai/glm-4.5-air": {
            id: "z-ai/glm-4.5-air",
            name: "GLM 4.5 Air",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 1.1,
            },
            limit: {
                context: 128000,
                output: 96000,
            },
        },
        "z-ai/glm-4.5v": {
            id: "z-ai/glm-4.5v",
            name: "GLM 4.5V",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-08-11",
            last_updated: "2025-08-11",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 1.8,
            },
            limit: {
                context: 64000,
                output: 16384,
            },
        },
        "z-ai/glm-4.5": {
            id: "z-ai/glm-4.5",
            name: "GLM 4.5",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.2,
            },
            limit: {
                context: 128000,
                output: 96000,
            },
        },
        "cognitivecomputations/dolphin3.0-mistral-24b": {
            id: "cognitivecomputations/dolphin3.0-mistral-24b",
            name: "Dolphin3.0 Mistral 24B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-02-13",
            last_updated: "2025-02-13",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "cognitivecomputations/dolphin3.0-r1-mistral-24b": {
            id: "cognitivecomputations/dolphin3.0-r1-mistral-24b",
            name: "Dolphin3.0 R1 Mistral 24B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-02-13",
            last_updated: "2025-02-13",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "qwen/qwen2.5-vl-72b-instruct": {
            id: "qwen/qwen2.5-vl-72b-instruct",
            name: "Qwen2.5 VL 72B Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-02-01",
            last_updated: "2025-02-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "qwen/qwen3-coder:free": {
            id: "qwen/qwen3-coder:free",
            name: "Qwen3 Coder 480B A35B Instruct (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "qwen/qwen3-235b-a22b-thinking-2507": {
            id: "qwen/qwen3-235b-a22b-thinking-2507",
            name: "Qwen3 235B A22B Thinking 2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.078,
                output: 0.312,
            },
            limit: {
                context: 262144,
                output: 81920,
            },
        },
        "qwen/qwen3-30b-a3b:free": {
            id: "qwen/qwen3-30b-a3b:free",
            name: "Qwen3 30B A3B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-04-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 40960,
                output: 40960,
            },
        },
        "qwen/qwen3-32b:free": {
            id: "qwen/qwen3-32b:free",
            name: "Qwen3 32B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-04-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 40960,
                output: 40960,
            },
        },
        "qwen/qwen3-max": {
            id: "qwen/qwen3-max",
            name: "Qwen3 Max",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-09-05",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.2,
                output: 6,
            },
            limit: {
                context: 262144,
                output: 32768,
            },
        },
        "qwen/qwen3-235b-a22b:free": {
            id: "qwen/qwen3-235b-a22b:free",
            name: "Qwen3 235B A22B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-04-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "qwen/qwen3-30b-a3b-instruct-2507": {
            id: "qwen/qwen3-30b-a3b-instruct-2507",
            name: "Qwen3 30B A3B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2025-04",
            release_date: "2025-07-29",
            last_updated: "2025-07-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 131072,
                output: 33000,
            },
        },
        "qwen/qwen-2.5-coder-32b-instruct": {
            id: "qwen/qwen-2.5-coder-32b-instruct",
            name: "Qwen2.5 Coder 32B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2024-11-11",
            last_updated: "2024-11-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "qwen/qwen2.5-vl-72b-instruct:free": {
            id: "qwen/qwen2.5-vl-72b-instruct:free",
            name: "Qwen2.5 VL 72B Instruct (free)",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-02",
            release_date: "2025-02-01",
            last_updated: "2025-02-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "qwen/qwen3-235b-a22b-07-25:free": {
            id: "qwen/qwen3-235b-a22b-07-25:free",
            name: "Qwen3 235B A22B Instruct 2507 (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-07-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "qwen/qwq-32b:free": {
            id: "qwen/qwq-32b:free",
            name: "QwQ 32B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03",
            release_date: "2025-03-05",
            last_updated: "2025-03-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "qwen/qwen2.5-vl-32b-instruct:free": {
            id: "qwen/qwen2.5-vl-32b-instruct:free",
            name: "Qwen2.5 VL 32B Instruct (free)",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03",
            release_date: "2025-03-24",
            last_updated: "2025-03-24",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "qwen/qwen3-coder": {
            id: "qwen/qwen3-coder",
            name: "Qwen3 Coder",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 1.2,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "qwen/qwen3-8b:free": {
            id: "qwen/qwen3-8b:free",
            name: "Qwen3 8B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-04-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 40960,
                output: 40960,
            },
        },
        "qwen/qwen3-235b-a22b-07-25": {
            id: "qwen/qwen3-235b-a22b-07-25",
            name: "Qwen3 235B A22B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-07-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.85,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "qwen/qwen3-next-80b-a3b-instruct": {
            id: "qwen/qwen3-next-80b-a3b-instruct",
            name: "Qwen3 Next 80B A3B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-09-11",
            last_updated: "2025-09-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.14,
                output: 1.4,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "qwen/qwen3-14b:free": {
            id: "qwen/qwen3-14b:free",
            name: "Qwen3 14B (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-04-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 40960,
                output: 40960,
            },
        },
        "tngtech/deepseek-r1t2-chimera:free": {
            id: "tngtech/deepseek-r1t2-chimera:free",
            name: "DeepSeek R1T2 Chimera (free)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2025-07",
            release_date: "2025-07-08",
            last_updated: "2025-07-08",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "nousresearch/hermes-4-405b": {
            id: "nousresearch/hermes-4-405b",
            name: "Hermes 4 405B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-08-25",
            last_updated: "2025-08-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 3,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "nousresearch/hermes-4-70b": {
            id: "nousresearch/hermes-4-70b",
            name: "Hermes 4 70B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-08-25",
            last_updated: "2025-08-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.13,
                output: 0.4,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "nousresearch/deephermes-3-llama-3-8b-preview": {
            id: "nousresearch/deephermes-3-llama-3-8b-preview",
            name: "DeepHermes 3 Llama 3 8B Preview",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-02-28",
            last_updated: "2025-02-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "moonshotai/kimi-k2-0905": {
            id: "moonshotai/kimi-k2-0905",
            name: "Kimi K2 Instruct 0905",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-09-05",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.5,
            },
            limit: {
                context: 262144,
                output: 16384,
            },
        },
        "moonshotai/kimi-k2:free": {
            id: "moonshotai/kimi-k2:free",
            name: "Kimi K2 (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-11",
            last_updated: "2025-07-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32800,
                output: 32800,
            },
        },
        "moonshotai/kimi-k2": {
            id: "moonshotai/kimi-k2",
            name: "Kimi K2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-11",
            last_updated: "2025-07-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.55,
                output: 2.2,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "moonshotai/kimi-dev-72b:free": {
            id: "moonshotai/kimi-dev-72b:free",
            name: "Kimi Dev 72b (free)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-06",
            release_date: "2025-06-16",
            last_updated: "2025-06-16",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
    },
};
export default openrouterModels;
//# sourceMappingURL=openrouter.js.map